import React, { FC } from 'react'
import Pagination from 'components/SA/Pagination'
import ResultsCount from 'components/SA/Pagination/ResultsCount'
import UrlConnector, { ConnectorProps as UrlProps } from '../connectors/Url'
import AlgoliaConnector, { ConnectorProps as AlgoliaProps } from '../connectors/Algolia'
import SelectHitsPerPage from '../components/SelectHitsPerPage'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import styles from './PaginationHitsPerPage.module.scss'

type UserArtworksPaginationProps = UrlProps & AlgoliaProps

const UserArtworksPagination: FC<UserArtworksPaginationProps> = (props) => {
  const {
    hitsPerPage,
    hitsTotal,
    currentPage,
    totalPages,
    updateUrl,
    urlWithParams, // Enable when facets are enabled
  } = props
  return (
    <div className={styles.paginationWrapper}>
      <div className={styles.paginationContainer}>
        <div className={styles.paginationContent}>
          <Pagination
            current={currentPage + 1}
            total={totalPages}
            onClickLink={({ currentHref }) => {
              handleScrollToTop(() => updateUrl(currentHref))
            }}
            urlWithParam={urlWithParams}
          />
          <ResultsCount
            hitsTotal={hitsTotal}
            hitsPerPage={hitsPerPage}
            category='Artwork'
            currentPage={currentPage}
          />
        </div>
        {!!hitsTotal && <SelectHitsPerPage />}
      </div>
    </div>
  )
}

export default UrlConnector(AlgoliaConnector(UserArtworksPagination))
